import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SelectArrow from '@material-ui/icons/KeyboardArrowDown';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { USER_ROLE_ADMIN, XC_URL } from '../../config';
import PropTypes from 'prop-types';
import i18n from 'i18n/i18n';
import _ from 'lodash';

const localize = i18n.loc.localize;
class GuestModal extends Component {

	constructor(props) {
		super(props);

		this.goToPage = this.goToPage.bind(this);

		const companiesWithAdminRole = Object.values(this.props.companies.rawDataById)
			.filter(company => company.userRole === USER_ROLE_ADMIN);

		this.state = { 
			companiesWithAdminRole,
			selectedCompanyId: _.get(companiesWithAdminRole, '[0].id')
		};
	}

	render() {
		const { modalShown } = this.props;

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				{this.renderGuestDialog()}
			</Dialog>
		);
	}

	renderGuestDialog() {
		return (<React.Fragment>
			<DialogContent>
				<DialogContentText variant='body1' color='default'>
					{localize('guest-modal-message')} 
					{!_.isEmpty(this.state.companiesWithAdminRole) && 
						localize('guest-modal-message-can-select-different-team')}
				</DialogContentText>

				{!_.isEmpty(this.state.companiesWithAdminRole) && (
					<React.Fragment>
						<DialogActions>
							{this.renderCompanySelector()}
						</DialogActions>
						<DialogActions>
							<Button
								key='upgrade-company-button'
								data-tid="button-upgrade-company-continue"
								variant='contained'
								color='primary'
								onClick={ this.goToPage }
							>
								{localize('continue')}
							</Button>
						</DialogActions>
					</React.Fragment>
				)}
				
				<DialogActions>
					<Button
						disableRipple
						data-tid="button-create-new-team"
						onClick={() => {
							window.location.href = XC_URL + '?create-company=true';
						}}
					>
						{localize('guest-modal-create-new-team')}
					</Button>
				</DialogActions>
			</DialogContent>
		</React.Fragment>);
	}

	renderCompanySelector() {
		return (<Select
			data-tid="upgrade-company-company-selector"
			value={this.state.selectedCompanyId}
			name="company"
			disableUnderline
			IconComponent={SelectArrow}
			onChange={(event) => {
				this.setState({selectedCompanyId: event.target.value});
			}}
		>
			<MenuItem value="" disabled>{localize('guest-modal-selector')}</MenuItem>
			{this.state.companiesWithAdminRole.map((company) => {
				return (<MenuItem
					key={company.id}
					value={company.id}
					data-tid={`upgrade-company-item-${company.displayName}`}>
					{company.displayName}
				</MenuItem>);
			})}
		</Select>
		);
	}

	goToPage() {
		window.location.href = `/#${this.state.selectedCompanyId}/?company-known=1`;
		window.location.reload();
	}	
}

GuestModal.propTypes = {
	companies: PropTypes.object,
	modalShown: PropTypes.bool,
	isDesktopApp: PropTypes.bool
};

const mapStateToProps = state => ({
	modalShown: state.modal.modalShown,
	companies: state.companies,
});

export default connect(
	mapStateToProps
)(GuestModal);


// WEBPACK FOOTER //
// ./src/components/Modal/GuestModal.js